import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { createEntitySearchAtom, tractEnumLoadableAtom } from '../atoms';
import {
  EntityAccountPicker,
  EntityAccountSelection,
} from '../entity-account-picker';

/**
 * The picker for an entity and CRM account, with its enums and its own entity
 * search. Shared by the batch default panel and the asset tearsheet.
 * @param {object} props - onChange receives each selection
 * @return {JSX.Element} The picker
 */
export const EntityAccountField = ({
  onChange,
}: {
  onChange: (selection: EntityAccountSelection) => void;
}) => {
  const enums = useAtomValue(tractEnumLoadableAtom);
  const searchAtom = useMemo(() => createEntitySearchAtom(), []);
  const data = enums.state === 'hasData' ? enums.data : null;
  return (
    <EntityAccountPicker
      accountType={data?.accountType ?? []}
      accountSource={data?.accountSource ?? []}
      searchAtom={searchAtom}
      onChange={onChange}
      // A page change in the URL would trip the page's unsaved-changes prompt.
      persistentPagination={false}
    />
  );
};
